export const useDebounceLock = (delay = 500) => {
  const isDebouncing = ref(false)

  const withDebounce = async (fn: () => void | Promise<void>) => {
    if (isDebouncing.value) return

    isDebouncing.value = true
    try {
      await fn()
    } finally {
      setTimeout(() => {
        isDebouncing.value = false
      }, delay)
    }
  }

  return { withDebounce, isDebouncing }
}
